// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  min-width: 70vw;
  margin: 2rem auto;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  transition: all 0.3s ease;
}

.profile-header {
  text-align: center;
  margin-bottom: 2rem;
}

.profile-header h1 {
  color: #6616cd;
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
  letter-spacing: 1px;
}

.profile-header p {
  color: #666;
  font-size: 1.1rem;
}

/* Tab Navigation */
.profile-tabs {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 2rem;
}

.tab-button {
  background: transparent;
  border: none;
  padding: 1rem 1.5rem;
  color: #999;
  font-size: 1rem;
  font-weight: 500;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-button::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 0;
  height: 3px;
  background: #6616cd;
  transition: width 0.3s ease;
}

.tab-button:hover {
  color: #6616cd;
}

.tab-button.active {
  color: #6616cd;
}

.tab-button.active::after {
  width: 100%;
}

/* Tab Content */
.profile-content {
  min-height: 300px;
}

.tab-content {
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* General Tab */
.general-tab {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.profile-photo-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
}

.profile-photo-container {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s ease;
  z-index: 2;
  background-color: rgba(102, 22, 205, 0.1);
}

.profile-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.profile-photo-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, #6616cd, #9900ff);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  color: white;
  font-weight: bold;
}

.change-photo-button {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  text-align: center;
  font-size: 0.8rem;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s ease;
  z-index: 3;
}

.profile-photo-container:hover .change-photo-button {
  opacity: 1;
}

.profile-info {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1.5rem;
}

.info-item {
  display: flex;
  margin-bottom: 1.5rem;
  align-items: center;
}

.info-item>span:first-child {
  font-weight: 600;
  width: 120px;
  color: #6616cd;
}

.username-change {
  display: flex;
  gap: 0.5rem;
  flex: 1 1;
}

.username-change input {
  flex: 1 1;
  padding: 0.7rem;
  border: 2px solid rgba(102, 22, 205, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #333;
  font-size: 0.95rem;
}

.update-username-btn {
  padding: 0.5rem 1rem;
  background: #6616cd;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
}

.update-username-btn:hover {
  background: #7728d9;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.error-message {
  color: #e53935;
  font-size: 0.9rem;
  margin-top: -1rem;
  margin-bottom: 1rem;
  margin-left: 120px;
}

/* Interests Tab */
.interests-section {
  background: rgba(255, 255, 255, 0.05);
  /* padding: 1.5rem; */
  border-radius: 15px;
}

/* Add these styles to your existing CSS file */

.interests-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.interests-header h3 {
  margin: 0;
  color: #6616cd;
}

.refresh-button {
  background: transparent;
  border: none;
  color: #6616cd;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.refresh-button:hover {
  background: rgba(102, 22, 205, 0.1);
  transform: rotate(30deg);
}

.refresh-button svg {
  fill: #6616cd;
}

.interests-count {
  font-size: 0.9rem;
  color: #666;
  margin: 0.5rem 0;
}

/* Improve the interests list scrolling for many interests */
.interests-list {
  max-height: 200px;
  overflow-y: auto;
  padding: 0.5rem;
  border-radius: 8px;
  background: rgba(102, 22, 205, 0.05);
  margin-bottom: 1rem;
}

/* Make sure the interest tags look good */
.interest-tag {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.edit-button {
  background: #6616cd;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin-left: 3.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.edit-button:hover {
  background: #7728d9;
}

.interests-editor {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.add-interest {
  display: flex;
  gap: 1rem;
}

.add-interest input {
  flex: 1 1;
  padding: 0.5rem;
  border: 2px solid rgba(102, 22, 205, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #333;
}

.interests-list,
.interests-display {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.interest-tag {
  background: rgba(102, 22, 205, 0.1);
  color: #6616cd;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

.interest-tag:hover {
  background: rgba(102, 22, 205, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.interest-tag.editable {
  padding-right: 0.5rem;
}

.interest-tag button {
  background: none;
  border: none;
  color: #6616cd;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0 0.3rem;
}

.save-button {
  background: #6616cd;
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.save-button:hover {
  background: #7728d9;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.add-interest button {
  padding: 0.6rem 1.2rem;
  background: #6616cd;
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Syne', sans-serif;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.add-interest button:hover {
  background: #7728d9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 22, 205, 0.2);
}

.add-interest button:active {
  transform: translateY(0);
  box-shadow: none;
}

.add-interest button:disabled {
  background: #e0e0e0;
  color: #999;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.add-interest button:disabled svg {
  opacity: 0.5;
}

/* Theme Tab */
.theme-tab {
  padding: 1rem;
}

.theme-tab h3 {
  text-align: center;
  margin-bottom: 2rem;
  color: #6616cd;
}

.theme-options {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1.5rem;
}

.theme-option {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  position: relative;
  overflow: hidden;
}

.theme-option:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.theme-option.selected {
  border: 2px solid #6616cd;
  box-shadow: 0 0 15px rgba(102, 22, 205, 0.5);
}

.theme-option.selected::after {
  content: '✓';
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  color: #6616cd;
  font-size: 1.2rem;
  font-weight: bold;
}

.theme-color {
  width: 100%;
  height: 100px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.theme-name {
  font-weight: 600;
  color: #333;
}

/* Disabled themes */
.theme-option:not([data-id="purple"]) {
  opacity: 0.7;
  position: relative;
}

.theme-option:not([data-id="purple"])::before {
  content: "Coming Soon";
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.9rem;
  z-index: 1;
}

/* Chat History Tab */
.history-tab {
  padding: 1rem;
}

.history-tab h3 {
  text-align: center;
  margin-bottom: 2rem;
  color: #6616cd;
}

.chat-history-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.chat-history-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.chat-history-item:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.chat-date {
  font-size: 0.8rem;
  color: #999;
  margin-bottom: 0.5rem;
}

.chat-summary {
  color: #333;
}

/* Work in Progress */
.work-in-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  min-height: 200px;
  text-align: center;
  color: #999;
  padding: 2rem;
}

.work-in-progress svg {
  fill: #6616cd;
  opacity: 0.5;
  animation: spin 4s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.work-in-progress p:first-of-type {
  font-size: 1.5rem;
  font-weight: 500;
  color: #6616cd;
}

/* Back to Home Button */
.back-home-button {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: transparent;
  border: none;
  color: #6616cd;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 1rem;
}

.back-home-button svg {
  width: 24px;
  height: 24px;
  fill: #6616cd;
  margin-right: 0.5rem;
}

.back-home-button:hover {
  transform: translateX(-5px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .profile-container {
    padding: 1rem;
    min-width: 90vw;
  }

  .profile-tabs {
    flex-wrap: wrap;
  }

  .tab-button {
    font-size: 0.9rem;
    padding: 0.8rem 1.2rem;
  }

  .theme-options {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .info-item>span:first-child {
    width: auto;
  }

  .username-change {
    width: 100%;
  }
}

.photo-instructions {
  margin-top: 1rem;
  text-align: center;
  font-size: 0.8rem;
  color: #666;
}

/* Demographic editing styles */
.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.info-header h3 {
  color: #6616cd;
  margin: 0;
}

.edit-demographics-btn {
  background: #6616cd;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.edit-demographics-btn:hover {
  background: #5014a8;
  transform: translateY(-2px);
}

.edit-input {
  flex: 1 1;
  padding: 0.5rem;
  border: 2px solid rgba(102, 22, 205, 0.2);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  font-size: 1rem;
}

.edit-input:focus {
  outline: none;
  border-color: #6616cd;
  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1);
}

.edit-select {
  flex: 1 1;
}

.edit-buttons {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: center;
}

.save-btn {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 0.7rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.save-btn:hover {
  background: #45a049;
  transform: translateY(-2px);
}

.cancel-btn {
  background: #f44336;
  color: white;
  border: none;
  padding: 0.7rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: #da190b;
  transform: translateY(-2px);
}`, "",{"version":3,"sources":["webpack://./src/pages/Profile/Profile.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAO;AACT;;AAEA;EACE,SAAO;EACP,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,+CAA+C;;AAE/C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,cAAc;AACd;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B","sourcesContent":[".profile-container {\n  min-width: 70vw;\n  margin: 2rem auto;\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  max-width: 1000px;\n  transition: all 0.3s ease;\n}\n\n.profile-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.profile-header h1 {\n  color: #6616cd;\n  margin-bottom: 0.5rem;\n  font-size: 2.5rem;\n  letter-spacing: 1px;\n}\n\n.profile-header p {\n  color: #666;\n  font-size: 1.1rem;\n}\n\n/* Tab Navigation */\n.profile-tabs {\n  display: flex;\n  justify-content: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  margin-bottom: 2rem;\n}\n\n.tab-button {\n  background: transparent;\n  border: none;\n  padding: 1rem 1.5rem;\n  color: #999;\n  font-size: 1rem;\n  font-weight: 500;\n  position: relative;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.tab-button::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  width: 0;\n  height: 3px;\n  background: #6616cd;\n  transition: width 0.3s ease;\n}\n\n.tab-button:hover {\n  color: #6616cd;\n}\n\n.tab-button.active {\n  color: #6616cd;\n}\n\n.tab-button.active::after {\n  width: 100%;\n}\n\n/* Tab Content */\n.profile-content {\n  min-height: 300px;\n}\n\n.tab-content {\n  animation: fadeIn 0.5s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* General Tab */\n.general-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.profile-photo-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.profile-photo-container {\n  position: relative;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin: 0 auto;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  z-index: 2;\n  background-color: rgba(102, 22, 205, 0.1);\n}\n\n.profile-photo {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  display: block;\n}\n\n.profile-photo-placeholder {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(45deg, #6616cd, #9900ff);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 3rem;\n  color: white;\n  font-weight: bold;\n}\n\n.change-photo-button {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 10px;\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  text-align: center;\n  font-size: 0.8rem;\n  cursor: pointer;\n  opacity: 0;\n  transition: all 0.3s ease;\n  z-index: 3;\n}\n\n.profile-photo-container:hover .change-photo-button {\n  opacity: 1;\n}\n\n.profile-info {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n.info-item {\n  display: flex;\n  margin-bottom: 1.5rem;\n  align-items: center;\n}\n\n.info-item>span:first-child {\n  font-weight: 600;\n  width: 120px;\n  color: #6616cd;\n}\n\n.username-change {\n  display: flex;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.username-change input {\n  flex: 1;\n  padding: 0.7rem;\n  border: 2px solid rgba(102, 22, 205, 0.2);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #333;\n  font-size: 0.95rem;\n}\n\n.update-username-btn {\n  padding: 0.5rem 1rem;\n  background: #6616cd;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 600;\n}\n\n.update-username-btn:hover {\n  background: #7728d9;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.error-message {\n  color: #e53935;\n  font-size: 0.9rem;\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  margin-left: 120px;\n}\n\n/* Interests Tab */\n.interests-section {\n  background: rgba(255, 255, 255, 0.05);\n  /* padding: 1.5rem; */\n  border-radius: 15px;\n}\n\n/* Add these styles to your existing CSS file */\n\n.interests-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.interests-header h3 {\n  margin: 0;\n  color: #6616cd;\n}\n\n.refresh-button {\n  background: transparent;\n  border: none;\n  color: #6616cd;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.refresh-button:hover {\n  background: rgba(102, 22, 205, 0.1);\n  transform: rotate(30deg);\n}\n\n.refresh-button svg {\n  fill: #6616cd;\n}\n\n.interests-count {\n  font-size: 0.9rem;\n  color: #666;\n  margin: 0.5rem 0;\n}\n\n/* Improve the interests list scrolling for many interests */\n.interests-list {\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 0.5rem;\n  border-radius: 8px;\n  background: rgba(102, 22, 205, 0.05);\n  margin-bottom: 1rem;\n}\n\n/* Make sure the interest tags look good */\n.interest-tag {\n  margin-bottom: 0.5rem;\n  font-size: 0.95rem;\n}\n\n.edit-button {\n  background: #6616cd;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  margin-left: 3.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.edit-button:hover {\n  background: #7728d9;\n}\n\n.interests-editor {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.add-interest {\n  display: flex;\n  gap: 1rem;\n}\n\n.add-interest input {\n  flex: 1;\n  padding: 0.5rem;\n  border: 2px solid rgba(102, 22, 205, 0.2);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #333;\n}\n\n.interests-list,\n.interests-display {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.interest-tag {\n  background: rgba(102, 22, 205, 0.1);\n  color: #6616cd;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.interest-tag:hover {\n  background: rgba(102, 22, 205, 0.2);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.interest-tag.editable {\n  padding-right: 0.5rem;\n}\n\n.interest-tag button {\n  background: none;\n  border: none;\n  color: #6616cd;\n  cursor: pointer;\n  font-size: 1.2rem;\n  padding: 0 0.3rem;\n}\n\n.save-button {\n  background: #6616cd;\n  color: white;\n  border: none;\n  padding: 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n}\n\n.save-button:hover {\n  background: #7728d9;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.add-interest button {\n  padding: 0.6rem 1.2rem;\n  background: #6616cd;\n  color: white;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Syne', sans-serif;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.add-interest button:hover {\n  background: #7728d9;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 22, 205, 0.2);\n}\n\n.add-interest button:active {\n  transform: translateY(0);\n  box-shadow: none;\n}\n\n.add-interest button:disabled {\n  background: #e0e0e0;\n  color: #999;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.add-interest button:disabled svg {\n  opacity: 0.5;\n}\n\n/* Theme Tab */\n.theme-tab {\n  padding: 1rem;\n}\n\n.theme-tab h3 {\n  text-align: center;\n  margin-bottom: 2rem;\n  color: #6616cd;\n}\n\n.theme-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1.5rem;\n}\n\n.theme-option {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.theme-option:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n}\n\n.theme-option.selected {\n  border: 2px solid #6616cd;\n  box-shadow: 0 0 15px rgba(102, 22, 205, 0.5);\n}\n\n.theme-option.selected::after {\n  content: '✓';\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  color: #6616cd;\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.theme-color {\n  width: 100%;\n  height: 100px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.theme-name {\n  font-weight: 600;\n  color: #333;\n}\n\n/* Disabled themes */\n.theme-option:not([data-id=\"purple\"]) {\n  opacity: 0.7;\n  position: relative;\n}\n\n.theme-option:not([data-id=\"purple\"])::before {\n  content: \"Coming Soon\";\n  position: absolute;\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  z-index: 1;\n}\n\n/* Chat History Tab */\n.history-tab {\n  padding: 1rem;\n}\n\n.history-tab h3 {\n  text-align: center;\n  margin-bottom: 2rem;\n  color: #6616cd;\n}\n\n.chat-history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.chat-history-item {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 1rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.chat-history-item:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.chat-date {\n  font-size: 0.8rem;\n  color: #999;\n  margin-bottom: 0.5rem;\n}\n\n.chat-summary {\n  color: #333;\n}\n\n/* Work in Progress */\n.work-in-progress {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  min-height: 200px;\n  text-align: center;\n  color: #999;\n  padding: 2rem;\n}\n\n.work-in-progress svg {\n  fill: #6616cd;\n  opacity: 0.5;\n  animation: spin 4s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.work-in-progress p:first-of-type {\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: #6616cd;\n}\n\n/* Back to Home Button */\n.back-home-button {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  background: transparent;\n  border: none;\n  color: #6616cd;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 1rem;\n}\n\n.back-home-button svg {\n  width: 24px;\n  height: 24px;\n  fill: #6616cd;\n  margin-right: 0.5rem;\n}\n\n.back-home-button:hover {\n  transform: translateX(-5px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .profile-container {\n    padding: 1rem;\n    min-width: 90vw;\n  }\n\n  .profile-tabs {\n    flex-wrap: wrap;\n  }\n\n  .tab-button {\n    font-size: 0.9rem;\n    padding: 0.8rem 1.2rem;\n  }\n\n  .theme-options {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  }\n\n  .info-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .info-item>span:first-child {\n    width: auto;\n  }\n\n  .username-change {\n    width: 100%;\n  }\n}\n\n.photo-instructions {\n  margin-top: 1rem;\n  text-align: center;\n  font-size: 0.8rem;\n  color: #666;\n}\n\n/* Demographic editing styles */\n.info-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.info-header h3 {\n  color: #6616cd;\n  margin: 0;\n}\n\n.edit-demographics-btn {\n  background: #6616cd;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.edit-demographics-btn:hover {\n  background: #5014a8;\n  transform: translateY(-2px);\n}\n\n.edit-input {\n  flex: 1;\n  padding: 0.5rem;\n  border: 2px solid rgba(102, 22, 205, 0.2);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #333;\n  font-size: 1rem;\n}\n\n.edit-input:focus {\n  outline: none;\n  border-color: #6616cd;\n  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1);\n}\n\n.edit-select {\n  flex: 1;\n}\n\n.edit-buttons {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  justify-content: center;\n}\n\n.save-btn {\n  background: #4CAF50;\n  color: white;\n  border: none;\n  padding: 0.7rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.save-btn:hover {\n  background: #45a049;\n  transform: translateY(-2px);\n}\n\n.cancel-btn {\n  background: #f44336;\n  color: white;\n  border: none;\n  padding: 0.7rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.cancel-btn:hover {\n  background: #da190b;\n  transform: translateY(-2px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
